import { render, staticRenderFns } from "./CalendarEventEditorFinish.vue?vue&type=template&id=54037a78&scoped=true&lang=pug&"
import script from "./CalendarEventEditorFinish.vue?vue&type=script&lang=ts&"
export * from "./CalendarEventEditorFinish.vue?vue&type=script&lang=ts&"
import style0 from "./CalendarEventEditorFinish.vue?vue&type=style&index=0&id=54037a78&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54037a78",
  null
  
)

export default component.exports